module.exports = __webpack_public_path__ + "img/golden-time.f85fabcf.png";